import React from "react";
import styled from "styled-components";

import { getConfig } from "../../../../../../utils/config";

const config = getConfig();

const colors = config.theme.colors;

const MenuLabel = styled.div`
  font-size: 12px;
  color: ${colors.white};
  text-transform: uppercase;
`;

export default MenuLabel;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/MenuLabel/index.jsx